import { isPair } from './pairedCards'

function getSingleMatch(sourceCard, hand, playerHand) {
  let possibleCards = new Array()
  let sortedCards
  let nonPairedCards = new Array()
  let nonPairedTargetCards = new Array()
  let hiddenCard

  const hiddenLength = hand.filter(card => {
    return card.displayClass === 'hidden'
  }).length
  // Check Rows
  if (hasValidRows(hand)) {
    possibleCards = [
      ...possibleCards,
      ...checkForMatch(sourceCard, hand.slice(0, 3), hiddenLength),
    ]
    possibleCards = [
      ...possibleCards,
      ...checkForMatch(sourceCard, hand.slice(3, 6), hiddenLength),
    ]
    possibleCards = [
      ...possibleCards,
      ...checkForMatch(sourceCard, hand.slice(6), hiddenLength),
    ]
  }

  // Check Cols
  if (hasValidCols(hand)) {
    possibleCards = [
      ...possibleCards,
      ...checkForMatch(sourceCard, [hand[0], hand[3], hand[6]], hiddenLength),
    ]
    possibleCards = [
      ...possibleCards,
      ...checkForMatch(sourceCard, [hand[1], hand[4], hand[7]], hiddenLength),
    ]
    possibleCards = [
      ...possibleCards,
      ...checkForMatch(sourceCard, [hand[2], hand[5], hand[8]], hiddenLength),
    ]
  }

  if (hiddenLength > 1) {
    hiddenCard = possibleCards.find(card => {
      return card.displayClass === 'hidden'
    })
    if (hiddenCard) {
      return hiddenCard
    }
  }

  const visibleCards = possibleCards.filter(card => {
    return card.displayClass === 'visible'
  })
  if (visibleCards.length > 1) {
    sortedCards = visibleCards.sort((a, b) => {
      return b.value - a.value
    })

    nonPairedCards = sortedCards.filter(card => {
      return !isPair(card, hand)
    })
    nonPairedTargetCards = nonPairedCards.filter(card => {
      return !isPair(card, playerHand)
    })
  } else if (visibleCards.length === 1) {
    if (!isPair(visibleCards[0], hand)) {
      nonPairedCards = visibleCards
    }
    if (!isPair(visibleCards[0], playerHand)) {
      nonPairedTargetCards = visibleCards
    }
  }
  if (nonPairedTargetCards.length > 0) return nonPairedTargetCards[0]

  if (nonPairedCards.length > 0) return nonPairedCards[0]

  return
}

function hasValidRows(hand) {
  if (hand[2].displayClass !== 'transparent') {
    return true
  }
  return false
}

function hasValidCols(hand) {
  if (hand[6].displayClass !== 'transparent') {
    return true
  }
  return false
}

function checkForMatch(sourceCard, cards) {
  let possibleCards = new Array()
  const matchedCards = cards.filter(card => {
    return card.displayClass === 'visible' && card.value === sourceCard.value
  })

  if (matchedCards.length === 0) {
    return possibleCards
  }
  const hiddenCards = cards.filter(card => {
    return card.displayClass === 'hidden'
  })

  if (hiddenCards.length > 0) {
    possibleCards = [...possibleCards, ...hiddenCards]
  }

  const unmatchedCards = cards.filter(card => {
    return card.displayClass === 'visible' && card.value !== sourceCard.value
  })

  if (unmatchedCards.length > 0) {
    possibleCards = [...possibleCards, ...unmatchedCards]
  }

  // Remove Jokers from possible single match cards
  possibleCards = possibleCards.filter(card => {
    return card.value !== -2
  })

  return possibleCards
}

export { getSingleMatch }
